import { ArrowUpRight } from "lucide-react";
import { CATEGORIES, waLink } from "../../lib/site";

export const Categories = () => {
  return (
    <section id="categories" className="relative py-20 md:py-32 bg-cream">
      <div className="container-narrow">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
          <div>
            <span className="overline">The Boutique</span>
            <h2 className="mt-3 font-serif text-4xl md:text-6xl text-ink leading-[1.05]">
              Curated by occasion,
              <br />
              <span className="italic text-garnet">crafted</span> by master weavers.
            </h2>
          </div>
          <p className="md:max-w-sm text-muteink leading-relaxed">
            Choose a category and we'll personally walk you through the season's most
            celebrated drapes — from heirloom silks to feather-light festive edits.
          </p>
        </div>

        <div className="grid grid-cols-12 gap-4 md:gap-6">
          {CATEGORIES.map((c, i) => {
            const spans = [
              "col-span-12 md:col-span-7 row-span-2 aspect-[4/5] md:aspect-auto md:h-[640px]",
              "col-span-12 md:col-span-5 aspect-[5/4] md:h-[310px]",
              "col-span-6 md:col-span-3 h-[260px] md:h-[310px]",
              "col-span-6 md:col-span-2 h-[260px] md:h-[310px]",
            ];
            return (
              <a
                key={c.name}
                href={waLink(`Hi! I'd like to see the ${c.name} collection.`)}
                target="_blank"
                rel="noreferrer"
                data-testid={`category-card-${c.name.toLowerCase()}`}
                className={`relative group overflow-hidden ${spans[i]}`}
              >
                <img
                  src={c.image}
                  alt={c.name}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1500ms] group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/15 to-transparent" />
                <div className="absolute inset-0 p-6 md:p-8 flex flex-col justify-end">
                  <span className="overline text-gold-soft">0{i + 1}</span>
                  <div className="flex items-end justify-between gap-4 mt-2">
                    <div>
                      <h3 className="font-serif text-3xl md:text-4xl text-cream">{c.name}</h3>
                      <p className="mt-2 text-cream/85 text-sm leading-relaxed max-w-xs">{c.blurb}</p>
                    </div>
                    <span className="shrink-0 w-11 h-11 rounded-full border border-cream/40 flex items-center justify-center text-cream group-hover:bg-gold group-hover:border-gold group-hover:text-ink transition-all">
                      <ArrowUpRight size={18} />
                    </span>
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Categories;
